import {areOptionListsEnabled} from "@/helpers/featureFlags";

export const NAV_LINKS = {
    dashboardLinks: [
      {
        id: "ANALYTICS_DASHBOARD_HANDLER",
        text: "navBar.dashboard",
        icon: "home.svg",
        page: "/dashboard",
      },
      {
        id: "ADMIN_USERS",
        text: "navBar.users",
        icon: "user.svg",
        page: "/users",
      },
      {
        id: "SU_MENU",
        text: "navBar.menu",
        icon: "menu-white.svg",
        page: "/menu",
      },
      {
        id: "ADMIN_GROUPS",
        text: "navBar.catalog",
        icon: "book-open.svg",
        page: "/catalog",
        quickViews: [
          {subtitle: "navBar.groups", page: "/catalog", commandId: "group"},
          {subtitle: "navBar.products", page: "/catalog?view=products", commandId: "product"},
        ],
      },
      {
        id: "ADMIN_PRODUCT_OPTIONS",
        text: "navBar.productOptions",
        icon: "list.svg",
        page: "/product_options",
      },
      {
        id: "ADMIN_TABLES",
        text: "navBar.tables",
        icon: "table.svg",
        page: "/tables",
      },
        {
            id: "ADMIN_DELIVERY_AREA",
            text: "navBar.deliveryAreas",
            icon: "mapw.svg",
            page: "/delivery-areas",
        },
      {
        id: "ADMIN_KITCHEN",
        text: "navBar.kitchen",
        icon: "kitchen.svg",
        page: "/kitchen",
      },
      {
        id: "ADMIN_PROMO_CODES",
        text: "navBar.promo",
        icon: "percent.svg",
        page: "/promo",
      },
      {
        id: "ADMIN_VOUCHERS",
        text: "navBar.vouchers",
        icon: "gift.svg",
        page: "/vouchers",
      },
      {
        id: "ADMIN_PICKUP",
        text: "navBar.pickup",
        icon: "mapw.svg",
        page: "/pickup",
      },
      {
        id: "ADMIN_PRINTERS",
        text: "navBar.printers",
        icon: "printer.svg",
        page: "/printers",
      },
      {
        id: "ADMIN_CLIENT_DATA",
        text: "navBar.clients",
        icon: "users.svg",
        page: "/clients",
      },
      {
        id: "ADMIN_INVOICE",
        text: "navBar.invoice",
        icon: "inbox.svg",
        page: "/invoice",
      },
      {
        id: "ADMIN_INTEGRATION",
        text: "navBar.extIntegration",
        icon: "integration.svg",
        page: "/external-integration",
      },
      {
        id: "ADMIN_DEVICES",
        text: "deviceStrings.device",
        icon: "device.svg",
        page: "/device",
      },
      {
        id: "ADMIN_PLAYLISTS",
        text: "generic.digitalMenu",
        icon: "monitor.svg",
        page: "/digital-menu",
      }
    ],
    analyticsLinks: [
      {
        id: "ANALYTICS_ACCOUNTS",
        text: "navBar.account_history",
        icon: "activity.svg",
        page: "/analytics/accounts",
      },
      {
        id: "ANALYTICS_PAYMENTS",
        text: "navBar.payments",
        icon: "credit-card.svg",
        page: "/analytics/payments",
        hidden: true,
      },
      {
        id: "ANALYTICS_ORDERS",
        text: "navBar.order_history",
        icon: "clock.svg",
        page: "/analytics/orders",
      },
      {
        id: "ANALYTICS_SHIFTS",
        text: "navBar.shift",
        icon: "service2.svg",
        page: "/analytics/shifts",
      },
    ],
    settingsLinks: [
      {
        id: "ACCOUNT_IMAGE",
        text: "imagePageStrings.name",
        icon: "picture.svg",
        page: "/media",
      },
      {
        id: "ACCOUNT_ICONS",
        text: "navBar.icons",
        icon: "crop.svg",
        page: "/icons",
      },
      {
        id: "ACCOUNTS_SETTINGS",
        text: "navBar.settings",
        icon: "settings.svg",
        page: "/settings",
      },
    ],
    superUserLinks: [
      {
        id: "SUPER_USER_CREATE_ORG",
        text: "navBar.createOrg",
        icon: "plus-square.svg",
        page: "/create-org",
      },
      {
        id: "SU_IMPORT_CSV",
        text: "navBar.importCSV",
        icon: "download2.svg",
        page: "/import-file"
      },
      {
        id: "SUPER_USER_CREATE_USER",
        text: "navBar.superUsers",
        icon: "user.svg",
        page: "/super-users"
      }
    ]
};

export const NAV_LINK_GROUPS = [
    {key: "dashboardLinks", title: "navBar.dashboard"},
    {key: "analyticsLinks", title: "navBar.analytics"},
    {key: "settingsLinks", title: "navBar.account"},
    {key: "superUserLinks", title: "navBar.superUser"},
];

const ADMIN_ONLY_LINKS = ["ACCOUNTS_SETTINGS", "ANALYTICS_PAYMENTS", "ADMIN_INTEGRATION", "ADMIN_PICKUP"];

export class NavLinksHelper {

    static group(key) {
        return (NAV_LINKS[key] || []).map((link) => ({...link}));
    }

    static isAllowed(link, user, isPhone) {
        if (!user) return false;

        if (ADMIN_ONLY_LINKS.includes(link.id) && user.type !== "ADMIN" && user.type !== "SUPER_USER") {
            return false;
        }

        if ((link.id === "SU_MENU" || link.id === "ADMIN_PLAYLISTS") && isPhone) {
            return false;
        }

        if (link.id === "SU_MENU") {
            if (user.type === "ADMIN" || user.type === "SUPER_USER") {
                return true;
            }
            const abilities = user.abilities || [];
            return abilities.includes("ADMIN_PRODUCTS") && abilities.includes("ADMIN_GROUPS");
        }

        if (link.id === "ADMIN_PLAYLISTS") {
            const organization = user.organization || {};
            if (!organization.digitalMenuEnabled) return false;
            if (user.type === "SUPER_USER" || user.type === "ADMIN") return true;
            return (user.abilities || []).includes("ADMIN_PLAYLISTS");
        }

        if (link.id === "ADMIN_GROUPS") {
            if (user.type === "ADMIN" || user.type === "SUPER_USER") {
                return true;
            }
            const abilities = user.abilities || [];
            return abilities.includes("ADMIN_GROUPS") && abilities.includes("ADMIN_PRODUCTS");
        }

        if (link.id === "ADMIN_PRODUCT_OPTIONS") {
            if (!areOptionListsEnabled()) {
                return false;
            }
            if (user.type === "ADMIN" || user.type === "SUPER_USER") {
                return true;
            }
            return (user.abilities || []).includes("ADMIN_PRODUCTS");
        }

        if (link.id === "ACCOUNT_ICONS") {
            return user.type === "SUPER_USER";
        }

        if (link.id === "SUPER_USER_CREATE_USER") {
            return (user.abilities || []).includes("SUPER_USER_CREATE_USER");
        }

        if (link.id === "SU_DASHBOARD") {
            return user.type === "SUPER_USER";
        }

        if (link.id === "ADMIN_DEVICES" || link.id === "SUPER_USER_CREATE_ORG" || link.id === "SU_IMPORT_CSV") {
            if (user.type !== "SUPER_USER") return false;
            if (link.id === "SUPER_USER_CREATE_ORG"
                && user.partnerSource
                && !(user.abilities || []).includes("SUPER_USER_CREATE_ORG")) {
                return false;
            }
            return true;
        }

        if (link.id === "ADMIN_PROMO_CODES" || link.id === "ADMIN_VOUCHERS") {
            if (!user.organization?.onlineOrderWebPageEnabled) return false;
        }

        if (link.id === "ANALYTICS_DASHBOARD_HANDLER") {
            if (user.type === "ADMIN" || user.type === "SUPER_USER") {
                return true;
            }
            const abilities = user.abilities || [];
            return abilities.includes("ANALYTICS_DASHBOARD")
                || abilities.includes("ANALYTICS_DASHBOARD_GROUPS");
        }

        if (user.type !== "ADMIN" && user.type !== "SUPER_USER") {
            return (user.abilities || []).includes(link.id);
        }
        return true;
    }

    static isBlackboxHidden(link) {
        if (process.env.VUE_APP_CERTIFIED !== "true") return false;
        return ["/invoice", "/promo", "/pickup"].includes(link.page);
    }

    static allowedLinks(user, isPhone) {
        return NAV_LINK_GROUPS.flatMap((group) => NavLinksHelper.group(group.key))
            .filter((link) => link.page && !link.hidden)
            .filter((link) => !NavLinksHelper.isBlackboxHidden(link))
            .filter((link) => NavLinksHelper.isAllowed(link, user, isPhone));
    }

    static findAllowedById(id, user, isPhone) {
        return NavLinksHelper.allowedLinks(user, isPhone).find((link) => link.id === id) || null;
    }

    static allLinks() {
        return NAV_LINK_GROUPS.flatMap((group) => NavLinksHelper.group(group.key)).filter((link) => link.page);
    }

    static findByPath(path) {
        if (!path) return null;

        const links = NavLinksHelper.allLinks();
        const exact = links.find((link) => link.page === path);
        if (exact) return exact;

        return links
            .filter((link) => link.page !== "/" && path.startsWith(`${link.page}/`))
            .sort((a, b) => b.page.length - a.page.length)[0] || null;
    }
}
